import { render, staticRenderFns } from "./DefaultBranch.vue?vue&type=template&id=7a9f9b94&"
import script from "./DefaultBranch.vue?vue&type=script&lang=js&"
export * from "./DefaultBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports